import { DiContainer } from 'utils/di';
import { HttpClient } from './http';
import { HttpClientInterface } from './http/types';
import { ServiceContainerInterface } from 'services/types';
import { CmsClient } from 'services/cms';
import { NewsServiceInterface } from 'services/news/types';
import NewsService from 'services/news/NewsService';
import CareersService from 'services//careers/CareersService';
import { CareersServiceInterface } from 'services//careers/types';

class ServiceContainer extends DiContainer implements ServiceContainerInterface {
  private get httpClient(): HttpClientInterface {
    return this.getInstance('httpClient', () => new HttpClient());
  }

  private get cmsClient(): HttpClientInterface {
    return this.getInstance('cmsClient', () => new CmsClient());
  }

  get newsService(): NewsServiceInterface {
    return this.getInstance('newsService', () => new NewsService(this.cmsClient));
  }

  get careersService(): CareersServiceInterface {
    return this.getInstance('careersService', () => new CareersService(this.cmsClient));
  }
}

export default ServiceContainer;
